import { render } from "./VerifiedEmail.vue?vue&type=template&id=08dc6f74"
const script = {}

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__